import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 2"
      portada="https://fullcomics18.org/img6/touchuukasou2-1.jpg"
   paginas={[
  "https://fullcomics18.org/img6/touchuukasou2-1.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-2.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-3.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-4.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-5.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-6.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-7.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-8.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-9.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-10.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-11.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-12.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-13.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-14.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-15.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-16.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-17.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-18.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-19.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-20.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-21.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-22.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-23.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-24.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-25.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-26.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-27.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-28.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-29.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-30.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-31.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-32.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-33.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-34.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-35.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-36.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-37.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-38.jpg",
  "https://fullcomics18.org/img6/touchuukasou2-39.jpg"
]}
      sugeridos={[]}


      info={{
         grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
etiquetas: ["Ahegao", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blackmail", "Blowjob", "C93", "Huge Breasts", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Shaved Head", "Sole Female", "Sole Male", "Sweating"],
        artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 2 ",
  portada: "https://fullcomics18.org/img6/touchuukasou2-1.jpg",
  reverso: "https://fullcomics18.org/img6/touchuukasou2-4.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Ahegao", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blackmail", "Blowjob", "C93", "Huge Breasts", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Shaved Head", "Sole Female", "Sole Male", "Sweating"],
    artistas: "Fuetakishi",
  },
};
